import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
//? English Version
import shareLockInstruction1 from "../../../assets/img/tutorialimages/shareLockGuide1.png";
import shareLockInstruction2 from "../../../assets/img/tutorialimages/shareLockGuide2.png";
import shareLockInstruction3 from "../../../assets/img/tutorialimages/shareLockGuide3.png";
import shareLockInstruction4 from "../../../assets/img/tutorialimages/shareLockGuide4.png";
import shareLockInstruction5 from "../../../assets/img/tutorialimages/shareLockGuide5.png";
import shareLockInstruction6 from "../../../assets/img/tutorialimages/shareLockGuide6.png";
import shareLockInstruction7 from "../../../assets/img/tutorialimages/shareLockGuide7.png";
//? Japanese Version
import shareLockInstruction1Jap from "../../../assets/img/tutorialimages/shareLockGuide1_Jap.jpg";
import shareLockInstruction2Jap from "../../../assets/img/tutorialimages/shareLockGuide2_Jap.jpg";
import shareLockInstruction3Jap from "../../../assets/img/tutorialimages/shareLockGuide3_Jap.jpg";
import shareLockInstruction4Jap from "../../../assets/img/tutorialimages/shareLockGuide4_Jap.jpg";
import shareLockInstruction5Jap from "../../../assets/img/tutorialimages/shareLockGuide5_Jap.jpg";
import shareLockInstruction6Jap from "../../../assets/img/tutorialimages/shareLockGuide6_Jap.jpg";
import shareLockInstruction7Jap from "../../../assets/img/tutorialimages/shareLockGuide7_Jap.jpg";
import shareLockInstruction8Jap from "../../../assets/img/tutorialimages/shareLockGuide8_Jap.jpg";

class ShareLockGuide extends Component {
  state = {
    language: "en",
  };

  componentDidMount() {
    if (auth.currentUser.uid) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            language: snapshot.val(),
          });
        });
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    if (this.state.language === "en") {
      return (
        <div
          style={{
            width: "80%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            className="imgStyle"
            src={shareLockInstruction1}
            alt="shareLockInstruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction2}
            alt="shareLockInstruction2"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction3}
            alt="shareLockInstruction3"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction4}
            alt="shareLockInstruction4"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction5}
            alt="shareLockInstruction5"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction6}
            alt="shareLockInstruction6"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction7}
            alt="shareLockInstruction7"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    } else if (this.state.language === "ja") {
      return (
        <div
          style={{
            width: "80%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            className="imgStyle"
            src={shareLockInstruction1Jap}
            alt="shareLockInstruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction2Jap}
            alt="shareLockInstruction2"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction3Jap}
            alt="shareLockInstruction3"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction4Jap}
            alt="shareLockInstruction4"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction5Jap}
            alt="shareLockInstruction5"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction6Jap}
            alt="shareLockInstruction6"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction7Jap}
            alt="shareLockInstruction7"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction8Jap}
            alt="shareLockInstruction8"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    } else if (this.state.language === "es") {
      return (
        <div
          style={{
            width: "80%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            className="imgStyle"
            src={shareLockInstruction1}
            alt="shareLockInstruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction2}
            alt="shareLockInstruction2"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction3}
            alt="shareLockInstruction3"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction4}
            alt="shareLockInstruction4"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              heightt: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction5}
            alt="shareLockInstruction5"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction6}
            alt="shareLockInstruction6"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={shareLockInstruction7}
            alt="shareLockInstruction7"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    }
  }
}

export default ShareLockGuide;
